import React from "react";
import { Eye } from "@phosphor-icons/react";
import { ActionButton, ActionGroup, StatusBadge } from "../app";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip";

const truncateCufe = (value) => {
  if (!value) return "-";
  return value.length > 30 ? `${value.slice(0, 30)}...` : value;
};

function CufeCell({ cufe }) {
  if (!cufe) return "-";

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className="inline-flex max-w-[220px] cursor-help font-mono text-xs text-[#9CA3AF]"
            tabIndex={0}
            title={cufe}
            aria-label={`CUFE: ${cufe}`}
          >
            {truncateCufe(cufe)}
          </span>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          className="max-w-sm break-all border border-[#242E42] bg-[#0B0E14] text-[#F3F4F6] shadow-xl"
        >
          {cufe}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export function createInvoiceColumns({
  t,
  getClientName,
  getClientRUC,
  onViewInvoice,
}) {
  return [
    {
      id: "invoice_number",
      header: t("invoiceNumber"),
      cellClassName: "text-[#E2B05E] font-medium",
      render: (invoice) => invoice.invoice_number,
      hideOnMobile: true,
    },
    {
      id: "quotation_number",
      header: "Cotización",
      cellClassName: "font-mono text-[#9CA3AF]",
      render: (invoice) => invoice.quotation_number || "-",
      hideOnMobile: true,
    },
    {
      id: "cufe",
      header: "CUFE",
      cellClassName: "text-[#9CA3AF]",
      render: (invoice) => <CufeCell cufe={invoice.cufe} />,
      hideOnMobile: true,
    },
    {
      id: "client",
      header: t("client"),
      cellClassName: "text-[#F3F4F6]",
      render: (invoice) => (
        <div className="flex flex-col">
          <span>{getClientName(invoice.client_id)}</span>
          {getClientRUC(invoice.client_id) ? (
            <span className="text-xs text-[#9CA3AF]" data-testid={`invoice-client-ruc-${invoice._id}`}>
              RUC: {getClientRUC(invoice.client_id)}
            </span>
          ) : null}
        </div>
      ),
      hideOnMobile: true,
    },
    {
      id: "issue_date",
      header: t("issueDate"),
      cellClassName: "text-[#9CA3AF]",
      mobileClassName: "text-[#9CA3AF]",
      render: (invoice) => invoice.issue_date,
    },
    {
      id: "due_date",
      header: t("dueDate"),
      cellClassName: "text-[#9CA3AF]",
      mobileClassName: "text-[#9CA3AF]",
      render: (invoice) => invoice.due_date,
    },
    {
      id: "total",
      header: t("total"),
      cellClassName: "font-['Outfit'] font-bold text-[#F3F4F6]",
      mobileClassName: "font-['Outfit'] font-bold text-[#F3F4F6]",
      render: (invoice) => `$${invoice.total?.toLocaleString()}`,
    },
    {
      id: "status",
      header: t("status"),
      render: (invoice) => (
        <StatusBadge value={invoice.status} statusContext="invoice" />
      ),
      hideOnMobile: true,
    },
    {
      id: "actions",
      header: t("actions"),
      actions: true,
      render: (invoice) => (
        <ActionGroup>
          <ActionButton
            icon={Eye}
            tone="view"
            iconOnly
            onClick={() => onViewInvoice(invoice)}
          />
        </ActionGroup>
      ),
    },
  ];
}
